import { GET_CYCLE, GET_CYCLE_ERROR, GET_CYCLE_SUCCESS, GET_PROGRESS } from './Kepler.actions'

const initialState = {
  loading: false,
  error: null,
  cycleData: [],
  progress: 0,
  loaded: 0,
  total: 0,
};

export const mapboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CYCLE:
      return { ...state, loading: true, error: null, progress: 0 };
    case GET_CYCLE_SUCCESS:
      return { ...state, loading: false, cycleData: action.payload.cycleData, progress: 100 };
    case GET_CYCLE_ERROR:
      return { ...state, loading: false, error: action.payload };
    case GET_PROGRESS:
      return { ...state, progress: action.payload.percent, loaded: action.payload.loaded, total: action.payload.total };
    default:
      return state;
  }
};

export default mapboxReducer
